import { ModalMerchantOpt, SDKConfig } from '@chargeafter/types-sdk';

export const convertSdkConfigToMerchantDetails = (
  sdkConfig: SDKConfig
): Exclude<SDKConfig, 'storeId'> => {
  if (!sdkConfig) {
    return sdkConfig;
  }

  const { storeId, merchantDetails = {}, ...rest } = sdkConfig;

  if (!storeId) {
    return sdkConfig;
  }

  return {
    ...rest,
    merchantDetails: {
      ...merchantDetails,
      storeId,
    },
  };
};

export const convertMerchantOptToMerchantDetails = (
  opt: ModalMerchantOpt
): Exclude<ModalMerchantOpt, 'posId' | 'posType'> => {
  const { posId, posType, merchantDetails = {}, ...rest } = opt;

  if (!posId && !posType) {
    return opt;
  }

  return {
    ...rest,
    merchantDetails: {
      ...merchantDetails,
      ...(posId && { posId }),
      ...(posType && { posType }),
    },
  };
};
